import { get } from '.';
import qs from 'qs';

export const getFacilities = ({ filters }) => {
  return get(`/facilities?${qs.stringify(filters)}`);
};
